import { useState } from "react";
import BottomSheet from "../../../../../components/common/bottom-sheet";

interface ReasonModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
}

const ReasonModal: React.FC<ReasonModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [selectedReason, setSelectedReason] = useState<string>("");
  const [tempCloseWeeks, setTempCloseWeeks] = useState<string>("");
  const [otherReason, setOtherReason] = useState<string>("");

  const handleReasonSelect = (reason: string) => {
    setSelectedReason(reason);
    if (reason !== "잠시만 꺼두려고 해요") {
      setTempCloseWeeks("");
    }
    if (reason !== "기타") {
      setOtherReason("");
    }
  };

  const handleSubmit = () => {
    let finalReason = "";

    // 잠시만 꺼두려고 해요 선택했으나 몇 주 정도 꺼두실 건지를 입력하지 않았을 때
    if (selectedReason === "잠시만 꺼두려고 해요") {
      if (!tempCloseWeeks.trim()) {
        alert("몇 주 정도 꺼두실 건지도 알려주세요! 😊");
        return;
      }
      finalReason = `${selectedReason} (${tempCloseWeeks}주)`;
    }
    // 기타 이유 선택했으나 이유를 입력하지 않았을 때
    else if (selectedReason === "기타") {
      if (!otherReason.trim()) {
        alert("기타 이유를 입력해주세요! 😊");
        return;
      }
      finalReason = otherReason;
    }
    // 아무 이유도 선택하지 않았을 때
    else {
      if (!selectedReason.trim()) {
        alert("선택 부탁드려요! 😊");
        return;
      }
      finalReason = selectedReason;
    }

    onSubmit(finalReason);
  };

  const handleClose = () => {
    setSelectedReason("");
    setTempCloseWeeks("");
    setOtherReason("");
    onClose();
  };

  return (
    <BottomSheet
      isOpen={isOpen}
      mainText="예약 주문을 쉬어갈까요?"
      onClose={handleClose}
      onButtonClick={handleSubmit}
      buttonText="완료"
      disableDrag={true}
    >
      <div className="px-1 py-2">
        <div className="text-gray-700 mb-4">
          <div className="text-xl font-medium mb-1 break-keep">
            어떤 점 때문에 예약 주문을 쉬어가시는지 궁금해요!
          </div>
          <div className="text-gray-500">편하게 남겨주세요 😊</div>
        </div>

        <div className="space-y-3">
          {[
            "예약 주문 사용이 불편해요",
            "예약 주문이 많이 들어오지 않아요",
            "실시간 판매에 집중하고 싶어요",
            "잠시만 꺼두려고 해요",
            "기타",
          ].map((reason) => (
            <div key={reason}>
              <button
                onClick={() => handleReasonSelect(reason)}
                className={`w-full p-3 text-left border rounded-lg transition-colors ${
                  selectedReason === reason
                    ? "bg-blue-500 text-white border-blue-500"
                    : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                }`}
              >
                {reason}
              </button>

              {selectedReason === reason &&
                reason === "잠시만 꺼두려고 해요" && (
                  <div className="mt-3 ml-3 p-3 bg-gray-50 rounded-lg">
                    <div className="text-md text-gray-600 mb-2">
                      몇 주 정도 꺼두실 예정인가요?
                    </div>
                    <div className="flex items-center space-x-2">
                      <input
                        type="number"
                        value={tempCloseWeeks}
                        onChange={(e) => setTempCloseWeeks(e.target.value)}
                        placeholder="숫자 입력"
                        className="w-20 p-2 border border-gray-300 rounded-lg text-center focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        min="1"
                        max="52"
                      />
                      <span className="text-gray-700">주</span>
                    </div>
                  </div>
                )}

              {selectedReason === reason && reason === "기타" && (
                <div className="mt-3 ml-3 p-3 bg-gray-50 rounded-lg">
                  <textarea
                    value={otherReason}
                    onChange={(e) => setOtherReason(e.target.value)}
                    placeholder="다른 이유가 있으시면 편하게 적어주세요"
                    className="w-full p-3 border border-gray-300 rounded-lg resize-none h-24 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    maxLength={200}
                  />
                  <div className="text-right text-sm text-gray-500 mt-1">
                    {otherReason.length}/200
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </BottomSheet>
  );
};

export default ReasonModal;
